module.exports = __webpack_public_path__ + "static/media/airbnb-badge.e619e016.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/airbnb-badge.svg
// module id = 265
// module chunks = 0